module.exports = "static/assets/41ebcde49032d543af1a2c843a725834.mp3";